export default __webpack_public_path__ + "static/media/stencil.f99575f5.svg";